export default "__VITE_ASSET__BL12JPFB__"